var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00078 0.400391C4.21294 0.400391 4.41646 0.484679 4.56646 0.634703L6.96646 3.0347C7.27886 3.34713 7.27886 3.85365 6.96646 4.16608C6.65406 4.47849 6.1475 4.47849 5.8351 4.16608L4.00078 2.33176L2.16647 4.16608C1.85405 4.47849 1.34752 4.47849 1.03509 4.16608C0.722677 3.85365 0.722677 3.34713 1.03509 3.0347L3.43509 0.634703C3.58512 0.484679 3.7886 0.400391 4.00078 0.400391ZM1.03509 7.83471C1.34752 7.52231 1.85405 7.52231 2.16647 7.83471L4.00078 9.66903L5.8351 7.83471C6.1475 7.52231 6.65406 7.52231 6.96646 7.83471C7.27886 8.14711 7.27886 8.65367 6.96646 8.96607L4.56646 11.3661C4.25406 11.6785 3.74752 11.6785 3.43509 11.3661L1.03509 8.96607C0.722677 8.65367 0.722677 8.14711 1.03509 7.83471Z",
    fill: "#525885"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.9684778944c8e35f8757d535d8c68099.svg";
export { ForwardRef as ReactComponent };